import { Flex, Text } from '@chakra-ui/react';
import { ButtonText } from '@morressier/alembic';
import {
  IActivityLog,
  ISubmissionFile
} from '@publishing-engine/domain/models';
import _ from 'lodash';
import { useState } from 'react';
import { IGetSubmissionWithdrawalResponse } from '@publishing-engine/submission-service/src/endpoints/api.response-types';
import { WithdrawalContextModal } from '../modals/WithdrawalContextModal';

export const SubmissionWithdrawal: React.FC<{
  changes?: IActivityLog['changes'];
  type:
    | 'EditorialSubmissionWithdrawn'
    | 'AuthorSubmissionWithdrawalRequested'
    | 'EditorialSubmissionWithdrawalAccepted';
}> = ({ changes, type }) => {
  const [show, setShow] = useState(false);
  const { submission } = changes?.reduce((acc, change) => {
    const [k, v] = Object.entries(change)[0] ?? ['', ''];
    return _.set(acc, k, v);
  }, {}) as {
    submission: {
      withdrawalReason: string;
      authorResponse: string;
      editorComment: string;
      attachments: ISubmissionFile[];
    };
  };

  const onClose = () => setShow(false);

  const content =
    type === 'EditorialSubmissionWithdrawn'
      ? submission.editorComment
      : submission.authorResponse;

  return (
    <Flex
      flexDirection={'column'}
      width={'100%'}
      alignItems={'flex-start'}
      gap={2}
    >
      <Text noOfLines={3}>{content}</Text>
      <ButtonText onClick={() => setShow(true)}>View Full Details</ButtonText>

      {show && (
        <WithdrawalContextModal
          role="editorial"
          onClose={onClose}
          data={submission as IGetSubmissionWithdrawalResponse}
          type={
            type === 'AuthorSubmissionWithdrawalRequested'
              ? 'AuthorSubmissionWithdrawalRequested'
              : 'EditorialSubmissionWithdrawn'
          }
        />
      )}
    </Flex>
  );
};
